import { render, staticRenderFns } from "./modalEditarCedis.vue?vue&type=template&id=60389e8c"
import script from "./modalEditarCedis.vue?vue&type=script&lang=js"
export * from "./modalEditarCedis.vue?vue&type=script&lang=js"
import style0 from "./modalEditarCedis.vue?vue&type=style&index=0&id=60389e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports